const normalizeKeyTermValue = (keyTerm: string): string[] => {
  const trimmedKeyTerm = keyTerm.trim();

  if (trimmedKeyTerm.startsWith('[') && trimmedKeyTerm.endsWith(']')) {
    try {
      const parsedKeyTerms: unknown = JSON.parse(trimmedKeyTerm);

      if (Array.isArray(parsedKeyTerms) && parsedKeyTerms.every((parsedKeyTerm) => typeof parsedKeyTerm === 'string')) {
        return parsedKeyTerms;
      }
    } catch {
      return [keyTerm];
    }
  }

  return [keyTerm];
};

export const KEY_TERMS_SEPARATOR_REGEXP = /[\n,;]/;
export const ASSEMBLY_KEYTERMS_MAX_TOTAL_WORDS = 1000;
export const ASSEMBLY_KEYTERM_MAX_PHRASE_WORDS = 6;
export const ASSEMBLY_KEYTERM_ENGLISH_REGEXP = /^[\x20-\x7E]+$/;

const KEYTERM_WORD_REGEXP = /\S+/g;
const KEYTERM_HAS_LETTER_OR_NUMBER_REGEXP = /[A-Za-z0-9]/;

export function normalizeKeyTerms(keyTerms: string[] | string = []): string[] {
  const rawKeyTerms = Array.isArray(keyTerms) ? keyTerms : [keyTerms];

  return rawKeyTerms
    .flatMap(normalizeKeyTermValue)
    .flatMap((keyTerm) => keyTerm.split(KEY_TERMS_SEPARATOR_REGEXP))
    .map((keyTerm) => keyTerm.trim())
    .filter((keyTerm) => !!keyTerm);
}

export function countKeyTermWords(keyTerm: string): number {
  return keyTerm.match(KEYTERM_WORD_REGEXP)?.length ?? 0;
}

export function getKeyTermsValidationError(keyTerms: string[]): string | null {
  let totalWords = 0;

  for (const keyTerm of keyTerms) {
    if (!ASSEMBLY_KEYTERM_ENGLISH_REGEXP.test(keyTerm) || !KEYTERM_HAS_LETTER_OR_NUMBER_REGEXP.test(keyTerm)) {
      return 'Only English keyterms are allowed.';
    }

    const keyTermWordsCount = countKeyTermWords(keyTerm);

    if (keyTermWordsCount > ASSEMBLY_KEYTERM_MAX_PHRASE_WORDS) {
      return `Each keyterm can contain up to ${ASSEMBLY_KEYTERM_MAX_PHRASE_WORDS} words.`;
    }

    totalWords += keyTermWordsCount;
  }

  if (totalWords > ASSEMBLY_KEYTERMS_MAX_TOTAL_WORDS) {
    return `Keyterms can contain up to ${ASSEMBLY_KEYTERMS_MAX_TOTAL_WORDS} total words.`;
  }

  return null;
}
